module.exports = __webpack_public_path__ + "img/hover_wx.811b61ac.png";